import { DefaultActions } from "../../../../components/page-releated/grp-standard-screen/actions";
import { type StandardGrpColumns } from "../../../../layout/grp-standard-screen";

import { IZones } from "../../../../shared/interfaces/IZones";

const tableColumns: StandardGrpColumns<IZones> = ({
    actionClick,
    columnClick,
}) => [
    {
        key: "action",
        name: "Ações",
        dataKey: "id",
        render(id) {
            return (
                <DefaultActions
                    value={id as unknown as number}
                    doAfterClick={actionClick}
                />
            );
        },
    },
    {
        key: "zonas_codigo",
        name: "Sigla",
        dataKey: "zonas_codigo",
        headerClick: columnClick,
    },
    {
        key: "zonas_tipo",
        name: "Nome Zona, Eixo ou Setor",
        dataKey: "zonas_tipo",
        headerClick: columnClick,
    },
    {
        key: "zonas_descricao",
        name: "Descrição (Características predominantes)",
        dataKey: "zonas_descricao",
        headerClick: columnClick,
    },
    {
        key: "zonas_leis_permitidas",
        name: "Uso - Permitido | Adequado",
        dataKey: "zonas_leis_permitidas",
        headerClick: columnClick,
    },
    {
        key: "zonas_leis_permissivas",
        name: "Uso - Permissivo | Condicionado",
        dataKey: "zonas_leis_permissivas",
        headerClick: columnClick,
    },
    {
        key: "zonas_leis_proibidas",
        name: "Uso - Proibido",
        dataKey: "zonas_leis_proibidas",
        headerClick: columnClick,
    },
    {
        key: "zonas_cnaes_permitidos",
        name: "CNAEs Permitidos",
        dataKey: "zonas_cnaes_permitidos",
        headerClick: columnClick,
    },
];

export default tableColumns;
